import HBButtonGroup from "@/components/HBButtonGroup";
import HBIcon from "@/components/HBIcon";
import { EVENT } from "@/constants/event";
import { SHORTCUT } from "@/constants/shortcut";
import useAppStore from "@/context/store";
import { button_click as buttonClickTracker } from "@/tracker/collecter/buttonClick";
import { getContentType } from "@/utils/getContentType";
import { usePinCreate } from "@/utils/hooks/usePinCreate";
import isEditingElement from "@/utils/isEditingElement";
import useOuterClick from "@/utils/useOuterClick";
import useShortcut from "@/utils/useShortcut";
import { Button, Dropdown } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import styles from "./index.module.less";
// eslint-disable-next-line no-unused-vars
// let hasCurrentPin = false;
/**
 *
 * @param {{
 *  pin: IPin,
 *  onOk?: (pin: IPin) => void,
 *  current: boolean,
 *  shortcutOrder?: number,
 * }} props
 * @param {*} actionRef
 * @returns
 */
function PinButton({ pin, onOk, current, shortcutOrder = 1 }, actionRef) {
  const [ref, visible, setVisible] = useOuterClick(false);
  const [board, setBoard] = useState(null);
  const [type, setType] = useState("flashTip");
  const router = useRouter();
  const { lastBoards, pinIds } = useAppStore(({ lastBoards, pinIds }) => ({
    lastBoards,
    pinIds,
  }));
  const pinitTimeoutRef = useRef(false);

  const { pinitModalRef, onFlash, onCreate } = usePinCreate({
    pin,
    onPinSuccess: (pin) => {
      setVisible(false);
      onOk?.(pin);
    },
    onPinWarn: (result) => {
      setBoard(result.pin?.board);
      setType("confirm");
      setVisible(true);
    },
  });

  const onCancel = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  const onFlashEnter = useCallback(() => {
    if (!visible) {
      setType("flashTip");
      setVisible(true);
    }
  }, [setVisible, visible]);

  const onFlashLeave = useCallback(() => {
    if (type === "flashTip") {
      setVisible(false);
    }
  }, [setVisible, type]);

  // 快捷键：采集 和 快采
  useShortcut(
    SHORTCUT.PIN,
    (e) => {
      setVisible(false);
      // 关注页面需要记录用户有没有操作
      if (router.pathname === "/follow") {
        window.dispatchEvent(new Event(EVENT.CARD_OPERATE));
      }
      if (e.ctrlKey || e.metaKey) {
        return false;
      }
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      const quickTime = 300; // 双击判断时长 ms

      if (pinitModalRef.current) {
        pinitModalRef.current.destroy();
        pinitModalRef.current = null;
        return false;
      }

      // 当前
      if (current) {
        const pinitTimeout = pinitTimeoutRef.current;

        // 快采
        if (pinitTimeout) {
          clearTimeout(pinitTimeout);

          // 1. 先设置为中间态 0
          pinitTimeoutRef.current = 0;

          // 2.再延时设置为 false
          setTimeout(() => {
            pinitTimeoutRef.current = false;
          }, quickTime);

          // 埋点上报
          buttonClickTracker(flashPinBtnRef.current, {
            other: {
              button_name: "快捷键快采",
            },
          });

          onFlash(true);
          return false;
        }

        if (pinitTimeout === 0) {
          return false;
        }

        // 转采
        pinitTimeoutRef.current = setTimeout(() => {
          onCreate();

          // 埋点上报
          // 埋点上报
          buttonClickTracker(pinBtnRef.current, {
            other: {
              button_name: "快捷键采集",
            },
          });

          // 1. 先设置为中间态 0
          pinitTimeoutRef.current = 0;

          // 2.再延时设置为 false
          setTimeout(() => {
            pinitTimeoutRef.current = false;
          }, quickTime);
        }, quickTime);

        return false;
      }
    },
    { order: shortcutOrder }
  );

  useImperativeHandle(actionRef, () => {
    return {
      create: onCreate,
      flash: onFlash,
    };
  });

  const overlay = useMemo(() => {
    if (type === "confirm") {
      return (
        <div className={styles.modal} ref={ref}>
          <div className={styles.content}>
            <span>该图片已在画板</span>
            <span className={styles.bold}>{board?.title}</span>
            <span>，要再次采集？</span>
          </div>
          <div className={styles.footer}>
            <Button
              className={styles.button}
              type="text"
              size="small"
              onClick={onCancel}
            >
              取消
            </Button>
            <Button
              className={styles.button}
              type="primary"
              size="small"
              onClick={() => onFlash(false)}
            >
              采集
            </Button>
          </div>
        </div>
      );
    }
    // } else if (type === "createBoard") {
    //   return (
    //     <div className={styles.modal} ref={ref}>
    //       <div className={styles.content}>当前无画板，请创建画板</div>
    //       <Form className={styles.form} ref={formRef}>
    //         <Form.Item name="title">
    //           <Input className={styles.input} placeholder="输入画板名称" />
    //         </Form.Item>
    //       </Form>
    //       <div className={styles.footer}>
    //         <Button
    //           className={styles.button}
    //           type="text"
    //           size="small"
    //           onClick={onCancel}
    //         >
    //           取消
    //         </Button>
    //         <Button
    //           className={styles.button}
    //           type="primary"
    //           size="small"
    //           onClick={onCreateBoard}
    //         >
    //           采集
    //         </Button>
    //       </div>
    //     </div>
    //   );
    // }

    return (
      <div className={styles.tooltip} ref={ref}>
        <span>
          {lastBoards?.length > 0 && lastBoards[0]?.title
            ? `快采到：${lastBoards[0]?.title}`
            : "快采到：待归类采集"}
        </span>
      </div>
    );
  }, [board, onCancel, onFlash, ref, type, lastBoards]);

  const isActive = useMemo(() => {
    return pinIds.includes(pin?.pin_id);
  }, [pin, pinIds]);

  const pinBtnRef = useRef();
  const flashPinBtnRef = useRef();

  return (
    <HBButtonGroup
      className={classNames([styles.action, isActive ? styles.active : null])}
    >
      <Button
        type="primary"
        className={styles.pick}
        onClick={onCreate}
        data-gd-click="button_click"
        data-button-name="采集"
        data-content-type={getContentType(pin?.extra)}
        data-pin-id={pin?.pin_id}
        data-board-id={pin?.board_id}
        data-file-id={pin?.file_id}
        data-ext={JSON.stringify(pin?.ext)}
        title={current ? "采集 [R]" : ""}
        ref={pinBtnRef}
      >
        {isActive ? "已采集" : "采集"}
      </Button>

      <Dropdown
        placement="bottomCenter"
        visible={visible}
        overlay={overlay}
        destroyPopupOnHide
      >
        <Button
          type="primary"
          className={styles.flash}
          onClick={() => onFlash(true)}
          onMouseEnter={onFlashEnter}
          onMouseLeave={onFlashLeave}
          data-gd-click="button_click"
          data-button-name="快采"
          data-pin-id={pin?.pin_id}
          data-board-id={pin?.board_id}
          data-file-id={pin?.file_id}
          title={current ? "快采 [R+R]" : ""}
          ref={flashPinBtnRef}
        >
          <HBIcon type="ic_flash" />
        </Button>
      </Dropdown>
    </HBButtonGroup>
  );
}

export default forwardRef(PinButton);
